import { useState } from 'react'
import { IconButton, Menu, MenuItem, Tooltip } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import { ActionConfirmDialog } from '@/apps/latest/components/molecules/ActionConfirmDialog'
import { colorTokens } from '@/apps/latest/shared/styles/colorTokens'
import { NOTION_MENU_PAPER_SX } from '@/apps/latest/shared/styles/menuStyles'

import { useDeleteNutritionRecord } from './useNutritionReport'

interface Props {
  // 選んだ回 (記録)
  eventId: string
  // 他の手 (録り直す・作る・もう一度文字起こす) の往復中は開かせない
  disabled?: boolean
  // 記録が消えた後に呼ぶ (カルテはそのまま。消えた回は回の選択から外れる)
  onDeleted?: () => void
}

// 回の行の右端の ⋯ (design-book ADR-0086 決定 7・02-components/popover-menu.md)。中身は「記録を削除」1 つで、消えるのは
// 選んだ回 (今回も前の回も)。削除は色で煽らず (fg.muted)、選んだ後に 1 行の確認を挟む。着地した記録も消せる
// (間違えた記録に気づくのは着地した後)。処理中は back が 409 で返し、toast で言う。今回を録っている間・送っている間・
// 作成中は、呼び出し側がどの回にも出さない (前の回を消すと、作っている今回が読む前回と指導回数が替わる)。
export const NutritionRoundMenu = ({ eventId, disabled, onDeleted }: Props) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)
  const [confirm, setConfirm] = useState(false)
  const remove = useDeleteNutritionRecord(eventId)

  return (
    <>
      <Tooltip title="その他">
        <span>
          <IconButton
            size="small"
            aria-label="その他"
            onClick={(e) => setAnchor(e.currentTarget)}
            disabled={disabled || remove.isPending}
            sx={{ color: colorTokens.fg.muted }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: NOTION_MENU_PAPER_SX } }}
      >
        <MenuItem
          onClick={() => {
            setAnchor(null)
            setConfirm(true)
          }}
          sx={{ color: colorTokens.fg.muted }}
        >
          記録を削除
        </MenuItem>
      </Menu>
      <ActionConfirmDialog
        open={confirm}
        title="記録を削除"
        body="録音・文字起こし・報告書・添付資料・メモをすべて消します。元に戻せません。"
        actionLabel="削除"
        onClose={() => setConfirm(false)}
        onConfirm={() => remove.mutate(undefined, { onSuccess: onDeleted })}
      />
    </>
  )
}
